// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"312":"d0b03f5e78c30d9e04a9","532":"55bcfe0f3a818c7b3ceb","668":"9682f0075a8f8e621797","691":"2f70ef151a6ae16d44ed","712":"8710626224fa252261d6"}[chunkId] + ".js";
};